/*
 * @Description: 客户确认
 * @Author: 杨志航
 * @Date: 2026-06-18 16:01:57
 */

import React, { useState, useEffect } from 'react'
import api from '@/api'
import {
  Form,
  Input,
  message,
  Upload,
  Icon,
  Checkbox,
} from 'antd'
import BtnGroup from '@/components/BtnGroup'
import { uploadDragger } from '@/utils/uploadDragger'
import { allTrim, filterParams } from '@/utils'

const FormItem = Form.Item
const { Dragger } = Upload
let draggerObj = {}

const CustomerConfirm = (props) => {
  const { getFieldDecorator, validateFields, getFieldsValue, setFieldsValue } = props.form
  const { setVisible, data, getList } = props
  const [saveLoading, setSaveLoading] = useState(false)

  useEffect(() => {
    draggerObj = uploadDragger({
      accept: '.jpg, .jpeg, .png, .pdf',
      limitNum: 5,
      limitSize: 10,
    })
    const { confirmStatus, confirmAttachments, confirmRemark } = data
    if (confirmStatus) {
      let status = []
      if (confirmStatus === 3) {
        status = [1, 2]
      } else {
        status = [confirmStatus]
      }
      setFieldsValue({
        confirmStatus: status,
      })
    }
    if (confirmAttachments) {
      setFieldsValue({
        attachments: JSON.parse(confirmAttachments).map((item, index) => {
          const { name, url } = item
          return {
            uid: index,
            name,
            status: 'done',
            url,
          }
        }),
      })
    }
    if (confirmRemark) {
      setFieldsValue({
        remark: confirmRemark,
      })
    }
  }, [])

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 6 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 18 },
    }
  }

  const formSubmit = (e) => {
    e.preventDefault()
    setFieldsValue(allTrim(getFieldsValue()))
    validateFields((err, vals) => {
      if (!err) {
        const { id } = data
        vals = filterParams(vals)
        vals.attachments = vals.attachments.map(item => {
          const { name, url } = item
          return {
            name,
            url,
          }
        })
        vals.confirmStatus = vals.confirmStatus.reduce((pre, cur) => pre + cur, 0)
        vals = {
          ...vals,
          id,
        }
        setSaveLoading(true)
        api.settlementOrderConfirm(vals).then(() => {
          setSaveLoading(false)
          setVisible(false)
          message.success('保存成功')
          getList()
        }).catch(() => setSaveLoading(false))
      }
    })
  }

  return (
    <div>
      <Form onSubmit={formSubmit} {...formItemLayout}>
        <FormItem label="结算单对方主体">
          {data.clientName || '--'}
        </FormItem>
        <FormItem label="客户确认方式">
          {getFieldDecorator('confirmStatus', {
            rules: [{ required: true, message: '请选择客户确认方式' }]
          })(
            <Checkbox.Group style={{ width: '100%' }} >
              <Checkbox value={1}>邮件确认</Checkbox>
              <Checkbox value={2}>盖章确认</Checkbox>
            </Checkbox.Group>
          )}
        </FormItem>
        <Form.Item label="附件上传">
          {getFieldDecorator('attachments', {
            valuePropName: 'fileList',
            getValueFromEvent: draggerObj.normFile,
            rules: [{ required: true, message: '请上传附件' }]
          })(
            <Dragger {...draggerObj}>
              <p className="ant-upload-drag-icon">
                <Icon type="inbox" />
              </p>
              <p className="ant-upload-text">点击或将文件拖拽到这里上传</p>
              <p className="ant-upload-hint">
                支持扩展名：.jpg、.jpeg、.png、.pdf<br/>单个文件大小不超过10M，不超过5个附件。
              </p>
            </Dragger>
          )}
        </Form.Item>
        <Form.Item label="备注信息">
          {getFieldDecorator('remark')(
            <Input.TextArea placeholder="请输入备注信息" rows={6} maxLength={500}/>
          )}
        </Form.Item>
        <BtnGroup onCancel={() => setVisible(false)} loading={saveLoading} />
      </Form>
    </div>
  );
}

export default Form.create()(CustomerConfirm)